import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number | null, autoTrigger = false) {
    const savedCallback: React.MutableRefObject<(() => void) | null> = useRef<() => void>(null);
    const intervalId = useRef<NodeJS.Timeout | null>(null);

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current?.();
        }

        // Clear any existing interval
        if (intervalId.current) {
            clearInterval(intervalId.current);
        }

        if (delay !== null) {
            // if the autoTrigger flag is set, call the callback immediately
            if (autoTrigger) {
                tick();
            }
            
            intervalId.current = setInterval(tick, delay);
            
            // Cleanup function
            return () => {
                if (intervalId.current) {
                    clearInterval(intervalId.current);
                }
            };
        }
    }, [delay, autoTrigger]);
    return intervalId.current;
}
